<template>
    <div>
    <el-row>
        <el-col id="distribution">
            <span v-on:click="setUpDistribution">
           <span class="graphType">{{type}}</span> {{count}}</span>
        </el-col>
        <el-col id="stats">
            
        </el-col>
    </el-row>
    <el-dialog class="distribution" :visible.sync="dialog">
        <el-row>
           <el-col :span="5">
               <el-date-picker
                    v-model="playbook[0].date_start"
                    size="small"
                    type="date"
                    placeholder="Pick a start day">
                </el-date-picker>
           </el-col>
            <el-col id="dateToPicker" :span="5">
               <el-date-picker
                    v-model="playbook[0].date_end"
                    size="small"
                    type="date"
                    placeholder="Pick an end day">
                </el-date-picker>
           </el-col>
           <el-col :span="16"></el-col>
        </el-row>
        <el-row>
             <el-divider content-position="left">Bot's tasks distribution settings</el-divider>
        </el-row>
        <el-row>
            <el-col id="dType" :span="6">
                <el-radio-group id="radios" v-model="playbook[0].graph">
                    <el-row>
                        <el-radio :label="'linear'">Linear</el-radio>
                    </el-row>
                    <el-row>
                        <el-radio :label="'gompertz'">Gompertz</el-radio>
                    </el-row>
                </el-radio-group>
            </el-col>
            <el-col id="distrs" :span="8">
                <el-row v-if="playbook[0].graph == 'linear'">
                    <el-row>
                        <el-col class="name" :span="9">
                            Goal:
                        </el-col>
                        <el-col :span="12">
                            <el-input
                                placeholder="Goal"
                                v-model="playbook[0].goal"
                                clearable>
                            </el-input>
                        </el-col>
                    </el-row>
                </el-row>
                <el-row v-if="playbook[0].graph == 'gompertz'">
                    <el-row>
                        <el-col class="name" :span="9">
                            Start count:
                        </el-col>
                        <el-col :span="12">
                            <el-input
                                placeholder="Start count"
                                v-model="playbook[0].start_count"
                                clearable>
                            </el-input>
                        </el-col>
                        
                    </el-row>
                    <el-row>
                        
                    </el-row>
                    <el-row>
                        <el-col class="name" :span="9">
                            Goal:
                        </el-col>
                        <el-col :span="12">
                            <el-input
                                placeholder="Goal"
                                v-model="playbook[0].goal"
                                clearable>
                            </el-input>
                        </el-col>
                    </el-row>
                     <el-row>
                        <el-col class="name" :span="9">
                            Growth period:
                        </el-col>
                        <el-col :span="12">
                            <el-tooltip content="Measured in days" placement="right">
                                <el-input
                                    placeholder="Growth period"
                                    v-model="playbook[0].growth_period"
                                    clearable>
                                </el-input>
                            </el-tooltip>
                        </el-col>
                    </el-row>
                    <el-row>
                        
                    </el-row>
                </el-row>
            </el-col>
            <el-col :span="12"></el-col>
        </el-row>
         <el-divider></el-divider>
        <el-row id="errors">
            <el-alert
                v-if="errors.length > 0"
                :title="errors[0]"
                type="error">
            </el-alert>
        </el-row>
        <el-row>
            <el-button v-on:click="saveDistribution" type="danger">
                Save changes
            </el-button>
        </el-row>

    </el-dialog>
    </div>
</template>

<script>
import moment from 'moment';
export default {
    name: 'Distribution',
    components: {
        
    },
    props: {
        playbook: {
            type: Array,
            default: () => {}
        },
        count: {
            type: Number,
            default: 0
        }
    },
    data () {
        return {
            dialog: false,
            radio: this.playbook[0].graph,
            errors: []
        }
    },
    computed: {
        type() {
            if (this.playbook[0].graph == 'linear') return 'L';
            if (this.playbook[0].graph == 'gompertz') return 'G';
            return '?';
        }
    },
    mounted: function () {
        var that = this;
        this.$store.subscribe((mutation, state) => {
            if (mutation.type === 'bot/BOT_UPDATED') {
                //so there is payload with id
                //mutation.payload.id
                that.dialog = false;
            }
        })
    },
    methods: {
        saveDistribution() {
            //validate
            this.prepareDates()
            
            if (!this.validate(this.playbook[0])) {
                return 1;
            }

            //call a new action
            var entity = {
                project_id: this.playbook[0].project_id,
                bot_id: this.playbook[0].bot_id,
                date_end: this.playbook[0].date_end,
                graph: this.playbook[0].graph
            };

            if (entity.graph == 'gompertz') {
                //fill out date_start, 
                entity.start_count = this.playbook[0].start_count;
                //entity.date_start = this.playbook[0].
            } else {

            }
            
            this.$store.dispatch('bot/updateBot', {model: this.playbook[0]});
            //this.$store.dispatch('project/setDistributionAction', entity);

        },
        prepareDates() {
            var start = moment(this.playbook[0].date_start)//.format('YYYY-MM-DD');
            var end = moment(this.playbook[0].date_end)//.format('YYYY-MM-DD');


            if (start.isValid())
                this.playbook[0].date_start = start.format('YYYY-MM-DD');


            if (end.isValid())
                this.playbook[0].date_end = end.format('YYYY-MM-DD');;    
            
        },
        validate(playbook) {
            this.errors = [];

            if (playbook.graph == 'linear') {
                if (playbook.goal <= 0) {
                    this.errors.push('Goal has to be greater than zero');
                    return false;
                }

                //todo add date end
            }
            
            if (playbook.graph == 'gompertz') {
                if (!(playbook.growth_period > 0)) {
                    this.errors.push('In case of gompertz distribution you have to specify growth period (measured in days)');    
                    return false;
                } 
                //validate date?
                var start_date = moment(playbook.date_start);
                var end_date = moment(playbook.date_end);
                if (playbook.start_count <= 0) {
                    this.errors.push('Check start and end count');
                    return false;
                } 
                
                if (!start_date.isValid() || (playbook.date_end && !end_date.isValid())) {
                    this.errors.push('Check you start & end dates');    
                    return false;
                }  
            }

            return true;
        },
        setUpDistribution() {
            this.dialog = true;
        },
        getGraph(){
            return (this.playbook.length) ? this.playbook[0].graph : 'not scheduled';
        },
        getName() {
          return this.botName;
        }
    }
}
</script>

<style lang="scss" scoped>
    #radios .el-row {
        margin-bottom: 10px;
        text-align: left;
    } 
    #errors {
        margin-bottom: 10px;
    }
    #distrs {
        
    }
    #dType {
        padding-top:15px;
    }
    #dateToPicker{
        margin-left:10px;
    }
    .el-input{
        padding-top: 5px !important;
    }
    .name {
        padding-top:15px;
    }
    #distribution {
        cursor: pointer;
    }
    .graphType{
        color:#ccc;
    }
</style>
